/**
 * Data management components module
 */
// modules
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AgGridModule } from 'ag-grid-angular';

import { CompanySelectionComponent } from '@components/app/home';
import { ModalWrapperModule } from '@components/modal-wrapper/modal-wrapper.module';

import { DateFormatPipe } from '../pipes/date-format.pipe';
import { MainHeaderComponent } from './app/main-header/main-header.component';
import { ValidationService } from './form/index';

@NgModule({
    imports: [
        AgGridModule.withComponents([]),
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        ModalWrapperModule,
    ],
    providers: [ValidationService, CurrencyPipe, DatePipe],
    declarations: [MainHeaderComponent, CompanySelectionComponent, DateFormatPipe],
    exports: [MainHeaderComponent, ReactiveFormsModule, AgGridModule, CompanySelectionComponent, DateFormatPipe],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DmComponentsModule {}
